import api from '../utils/api';

const publicAdmissionsService = {
  getSchoolInfo: async (schoolCode) => {
    try {
      return await api.get(`/api/public/schools/${schoolCode}`);
    } catch (error) {
      console.error('Error fetching school info:', error);
      throw error;
    }
  },

  submitApplication: async (schoolCode, data) => {
    try {
      return await api.post(`/api/public/admissions/${schoolCode}/apply`, data);
    } catch (error) {
      console.error('Error submitting application:', error);
      throw error;
    }
  },

  uploadDocuments: async (schoolCode, applicantId, files) => {
    try {
      const formData = new FormData();
      files.forEach(({ file }) => formData.append('files', file));
      files.forEach(({ documentType }) => formData.append('document_types', documentType));
      return await api.post(`/api/public/admissions/${schoolCode}/apply/${applicantId}/documents`, formData);
    } catch (error) {
      console.error('Error uploading documents:', error);
      throw error;
    }
  },

  checkPaymentStatus: async (schoolCode, reference) => {
    try {
      return await api.get(`/api/public/admissions/${schoolCode}/payment/status/${reference}`);
    } catch (error) {
      console.error('Error checking payment status:', error);
      throw error;
    }
  },

  getDepositInfo: async (schoolCode, depositId) => {
    try {
      return await api.get(`/api/public/admissions/${schoolCode}/deposits/${depositId}`);
    } catch (error) {
      console.error('Error fetching deposit info:', error);
      throw error;
    }
  },

  payDeposit: async (schoolCode, depositId, amount) => {
    try {
      return await api.post(`/api/public/admissions/${schoolCode}/deposits/${depositId}/pay`, { amount: amount || null });
    } catch (error) {
      console.error('Error starting deposit payment:', error);
      throw error;
    }
  },

  checkDepositPaymentStatus: async (schoolCode, depositId, reference) => {
    try {
      return await api.get(`/api/public/admissions/${schoolCode}/deposits/${depositId}/payment/status/${reference}`);
    } catch (error) {
      console.error('Error checking deposit payment status:', error);
      throw error;
    }
  },
};

export default publicAdmissionsService;
